<template>
  <div class="social-login d-flex justify-content-center align-items-center">
    <div class="w-100">
      <login-with-google :label="googleLabel" @on-success="onSuccess" />
    </div>
  </div>
</template>

<script>
/**
 * ==================================================================================
 * @Social login
 * ==================================================================================
 **/

import { mapGetters, mapMutations, mapActions } from 'vuex'
import Form from '@/utils/form'
import LoginWithGoogle from '@/components/buttons/LoginWithGoogle'

export default {
  components: {
    LoginWithGoogle
  },
  props: {
    googleLabel: {
      type: String,
      default: 'Sign in with Google'
    },

    /**
     * Custom callback function on successful login
     * @type {Function}
     */
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      form: new Form({})
    }
  },
  methods: {
    ...mapActions({
      social: 'auth/social',
      addAlert: 'alert/addAlert'
    }),
    ...mapGetters({
      getNeededVerification: 'auth/getNeededVerification'
    }),
    ...mapMutations({
      clearGoogleToken: 'auth/clearGoogleToken'
    }),
    async onSuccess(payload) {
      await this.social(payload)
        .then(() => {
          /**
           * Run custom callback if it exists, if not redirect user
           * to onboarding page if they're missing a verification item
           */

          if (this.callback) {
            this.callback()
          } else {
            let route = this.getNeededVerification()
            if (route) {
              this.$router.replace(route)
            } else {
              route = this.$route.query.redirect
                ? { path: this.$route.query.redirect }
                : { name: 'home' }

              this.$router.replace(route)
            }
          }
        })
        .catch(error => {
          this.clearGoogleToken()
          this.form.$handleError(error)
          this.addAlert({
            state: false,
            label: this.form.$errorMessage
          })
        })
    }
  }
}
</script>
<style scoped lang="scss">
.social-logins {
}
</style>
